import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useStartSurvey } from '@hooks/register/surveys/use-start-survey';
import { useSession } from '@hooks/security/use-session';
import { surveyLinkMap } from '@/types/dashboard';

const DASHBOARD_LINK = '/register/donate';

/**
 * The React stand-in for RegisterController.StartSurvey: the API can't redirect the
 * browser, so it answers with where the donor belongs and this page goes there —
 * client-side for a migrated survey, a full navigation for one still in Razor.
 */
const StartSurvey = () => {
    const { registrationId, editKey } = useSession();
    const { start, error } = useStartSurvey(registrationId, editKey);

    const navigate = useNavigate();
    const hasStarted = useRef(false);

    useEffect(() => {
        if (hasStarted.current) return;

        hasStarted.current = true;

        start().then((result) => {
            if (!result.ok) return;

            if (result.redirectUrl) {
                window.location.assign(result.redirectUrl);

                return;
            }

            const nextLink = surveyLinkMap.find((x) => x.step === result.nextStep);

            navigate(nextLink ? nextLink.link : DASHBOARD_LINK, { replace: true });
        });
    }, [start, navigate]);

    // BusyOverlay covers the wait, so there is nothing to show unless the hand-off failed.
    if (!error) return null;

    return (
        <div className="row">
            <div className="col-xs-12">
                <div className="alert alert-danger">{error}</div>
            </div>
        </div>
    );
};

export default StartSurvey;
